import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Form, Icon, Input } from 'antd';
import * as React from 'react';

export interface ITreeViewItemInputsProps {
    componentKey: string;
    valueInputDefaultValue?: string;
    pointsInputDefaultValue?: string;

    customValuePlaceholder?: string;
    customPointsPlaceholder?: string;

    onChangeValueField?: Function;
    onChangePointsField?: Function;

    showDraggablePart?: boolean;

    onRemoveItem?: Function;
    externalValidator: Function;

    form: any;
}

export interface ITreeViewItemInputsState {
}

const FormItem = Form.Item;

export default class TreeViewItemInputs extends React.Component<ITreeViewItemInputsProps, ITreeViewItemInputsState> {

    constructor(props: ITreeViewItemInputsProps) {
        super(props);

        this.state = {
            showDraggablePart: false,
            form: undefined,
        }

        this.removeItem = this.removeItem.bind(this);
        this.onChangeValueField = this.onChangeValueField.bind(this);
        this.onChangePointsField = this.onChangePointsField.bind(this);
        this.validateFields = this.validateFields.bind(this);
    }

    componentDidMount() {
        if (this.props.externalValidator) {
            this.props.externalValidator(this.validateFields);
        }
    }

    removeItem() {
        if (this.props.onRemoveItem) {
            this.props.onRemoveItem(this.props.componentKey);
        }
    }

    onChangeValueField(e: any) {
        if (this.props.onChangeValueField) {
            this.props.onChangeValueField(this.props.componentKey, e.target.value);
        }
    }

    onChangePointsField(e: any) {
        if (this.props.onChangePointsField) {
            this.props.onChangePointsField(this.props.componentKey, e.target.value);
        }
    }

    validateFields(): boolean {
        let hasError: boolean = false;
        this.props.form.validateFields((err: any, values: any) => {
            hasError = err;
            return !err;
        });
        return !hasError;
    }

    render() {

        const { getFieldDecorator } = this.props.form;

        const {
            valueInputDefaultValue,
            pointsInputDefaultValue,
            customValuePlaceholder,
            customPointsPlaceholder,
            showDraggablePart,
            onRemoveItem,
            componentKey
        } = this.props;
        return (
            <InputsWrapper>

                <Form hideRequiredMark={true}>
                    {showDraggablePart && (
                        <DraggablePart>
                            <DraggablePartIconWrapper>
                                <FontAwesomeIcon icon={'grip-horizontal'} />
                            </DraggablePartIconWrapper>
                        </DraggablePart>
                    )}
                    <FormItem
                        colon={false}
                        className={'value-input-field'}
                    >
                        {getFieldDecorator(`value-${componentKey}`, {
                            rules: [
                                { required: true, message: I18n.l('form.validation.field.required'), whitespace: false },
                                {
                                    min: 3, message: I18n.l('form.validation.text.min')
                                },
                                {
                                    max: 150, message: I18n.l('form.validation.text.max')
                                }],
                            initialValue: valueInputDefaultValue ? valueInputDefaultValue : ''
                        }
                        )(
                            <Input
                                onChange={this.onChangeValueField}
                                placeholder={customValuePlaceholder ? customValuePlaceholder : I18n.l('formflow.components.selectComponent.treeView.listItem')}
                            />
                        )}
                    </FormItem>
                    <FormItem
                        colon={false}
                    >
                        {getFieldDecorator(`points-${componentKey}`, {
                            initialValue: pointsInputDefaultValue ? pointsInputDefaultValue : '',
                        },
                        )(
                            <Input
                                type='number'
                                onChange={this.onChangePointsField}
                                min={0}
                                placeholder={customPointsPlaceholder ? customPointsPlaceholder : I18n.l('formflow.components.treeViewComponent.points')}
                            />
                        )}
                    </FormItem>
                    {onRemoveItem && (
                        <div>
                            <Icon
                                className={'delete-icon'}
                                type="close"
                                onClick={this.removeItem}
                            />
                        </div>
                    )}
                </Form>

            </InputsWrapper>
        )
    }
}

const DraggablePart = styled.div`
    background: ${Theme.secondary.midGrey};
    height: auto;
    width:34px;
    height:32px;
    cursor: grab;
    border-radius: 4px 0px 0px 4px;
    margin-top: 4px;

`

const DraggablePartIconWrapper = styled.div`
    display:flex;
    flex-flow: column;
    justify-content: center;
    height: 100%;
    color: white;
    align-items: center;
`

const InputsWrapper = styled.div`
    display:flex;
    flex-flow: row;
    justify-content:flex-start;
    align-items:center;

    .ant-input:first-child{
        border-radius: 0px 1px 1px 0px;
    }
    
    .value-input-field{
        margin-right: 15px;
    }

    .ant-form{
        display:flex;
        flex-flow: row;
        justify-content:flex-start;

        .ant-form-item{
            margin-bottom: 0px;
        }
    }

    .delete-icon{
        color:#f00;
        margin-left: 10px;
        cursor: pointer;
        margin-top: 12px;
    }
    
`

export const TreeViewItemInputsComponent = Form.create()(TreeViewItemInputs);